import HireXLPagination from './Pagination.react'

export default HireXLPagination